import type { TFunction } from "i18next";

export type ApplicationFilter =
  "Accepted" | "All" | "Declined" | "Offered" | "Withdrawn";

export type ApplicationListView = "All" | "Pending";

export interface ApplicationFilterOption {
  readonly label: string;
  readonly value: ApplicationFilter;
}

export function getApplicationFilterOptions(
  t: TFunction,
): ApplicationFilterOption[] {
  return [
    { value: "All", label: t("ApplicationsCompany.AllStatuses") },
    { value: "Accepted", label: t("ApplicationsCompany.Hired") },
    { value: "Declined", label: t("GigsCompany.Declined") },
    { value: "Withdrawn", label: t("Schedule.Withdrawn") },
    { value: "Offered", label: t("GigsCompany.Offered") },
  ];
}

export function isApplicationFilter(value: string): value is ApplicationFilter {
  switch (value) {
    case "Accepted":
    case "All":
    case "Declined":
    case "Offered":
    case "Withdrawn":
      return true;
    default:
      return false;
  }
}
